/**
 * Cookie utilities for managing modal dismissal state
 */

const COOKIE_EXPIRY_HOURS = 24;

export const setCookie = (name: string, value: string, hours: number = COOKIE_EXPIRY_HOURS) => {
	const date = new Date();
	date.setTime(date.getTime() + hours * 60 * 60 * 1000);
	const expires = `expires=${date.toUTCString()}`;
	document.cookie = `${name}=${value};${expires};path=/`;
};

export const getCookie = (name: string): string | null => {
	const nameEQ = `${name}=`;
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		if (!c) continue;
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
};

export const deleteCookie = (name: string) => {
	document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

// Modal-specific cookie helpers
export const MODAL_DISMISSED_PREFIX = 'dismissed_modal_';

export const isModalDismissed = (modalId: string): boolean => {
	return getCookie(`${MODAL_DISMISSED_PREFIX}${modalId}`) === 'true';
};

export const dismissModal = (modalId: string) => {
	setCookie(`${MODAL_DISMISSED_PREFIX}${modalId}`, 'true', COOKIE_EXPIRY_HOURS);
};
